import React, { useState, useEffect } from 'react';
import {useDataProvider} from 'react-admin';

export var API_VERSION = '0.0';
const Version = () =>{
   const [apiVersion, changeApiVersion] = useState('0.0');
   const dataProvider = useDataProvider();
   useEffect(()=>{
      dataProvider.getOne('version', {})
      .then(({ data }) => {
         changeApiVersion(data.api_version.value);
         API_VERSION = data.api_version.value;
      })
      .catch(error => {
      })
   },[dataProvider]);
   return ( 
      <div>{'Tag: ' + process.env.REACT_APP_VERSION +', API: ' + apiVersion}</div>
   )
}
export default Version;